export const isDeeplinkFormat = (deepLinkUrl: string): boolean => {
    return deepLinkUrl.includes('onelink.me') || deepLinkUrl.includes('lotuss://lotuss')
}

export const isWebsiteFormat = (deepLinkUrl: string): boolean => {
    if (!deepLinkUrl) return false
    return deepLinkUrl.startsWith('https://')
}

export const isValidImageUrl = (url?: string): boolean => {
    return !!url && url.trim() !== '' && url.startsWith('http')
}

export const isWithinDisplayPeriod = (start: string, end: string): boolean => {
    const now = new Date()
    return now >= new Date(start) && now <= new Date(end)
}